import * as React from 'react'

import moment from 'moment'
import { ActivityModel } from 'app/models'
import { getDurationBetweeenDates, formatDateTime } from 'app/common/dateHelper'

import { TooltipLayout } from './ToolTipLayout'
import { getActivityColor } from '@/modules/drivers/helpers/ActivityColorResolver'
import { getActivityName } from '@/modules/drivers/helpers/ActivityNameResolver'
import { getActivityNavbarIcon } from '@/modules/drivers/helpers/ActivityIconResolver'

type ActivityTooltipProps = {
  activity: ActivityModel
  translate: (text) => any
}
type ActivityTooltipState = {}

export class ActivityTooltip extends React.Component<ActivityTooltipProps> {
  private formatBoolean = (value): string =>
    value
      ? this.props.translate('answer.yes')
      : this.props.translate('answer.no')

  private getModifiedByName = (): string => {
    const { modifiedBy } = this.props.activity

    if (!modifiedBy) return '-'

    return modifiedBy
  }

  render() {
    const {
      startTime,
      endTime,
      type,
      registrationNumber,
      isVehicleActive,
      isManualEntry,
      isCrew,
      isOutOfScope,
      isFerryCrossing,
      driver,
      isVehicleSource,
      coDriver,
      isModifiedByUser,
      modified,
    } = this.props.activity

    const rows = [
      {
        title: this.props.translate('activity.startTime'),
        value: formatDateTime(startTime),
      },
      {
        title: this.props.translate('activity.endTime'),
        value: formatDateTime(endTime),
      },
      {
        title: this.props.translate('activity.duration'),
        value: getDurationBetweeenDates(
          moment(startTime).toDate(),
          moment(endTime).toDate(),
        ),
      },
      ...(driver == null
        ? [
            {
              title: this.props.translate('activity.registration-number'),
              value: registrationNumber || '-',
            },
            ...(registrationNumber && isVehicleActive !== undefined
              ? [
                  {
                    title: this.props.translate('activity.vehicle-active'),
                    value: this.formatBoolean(isVehicleActive),
                  },
                ]
              : []),
          ]
        : [
            {
              title: this.props.translate('activity.driver'),
              value: driver || '-',
            },
          ]),
      ...(coDriver
        ? [
            {
              title: this.props.translate('activity.co-driver'),
              value: coDriver,
            },
          ]
        : []),
      ...(driver == null
        ? [
            {
              title: this.props.translate('activity.manual-entry'),
              value: this.formatBoolean(isManualEntry),
            },
          ]
        : []),
      {
        title: this.props.translate('activity.crew'),
        value: this.formatBoolean(isCrew),
      },
      {
        title: this.props.translate('activity.out-of-scope'),
        value: this.formatBoolean(isOutOfScope),
      },
      {
        title: this.props.translate('activity.ferry-crossing'),
        value: this.formatBoolean(isFerryCrossing),
      },
      ...(isModifiedByUser
        ? [
            {
              title: this.props.translate('activity.modified-by'),
              value: this.getModifiedByName(),
            },
            {
              title: this.props.translate('activity.modified-date'),
              value: modified
                ? moment(modified).format('DD.MM.YYYY HH:mm')
                : '-',
            },
          ]
        : []),
    ]

    return (
      <TooltipLayout
        headerColor={getActivityColor(this.props.activity, false)}
        headerTextColor={'#000000'}
        headerIcon={getActivityNavbarIcon(this.props.activity)}
        headerTitle={this.props.translate(getActivityName(type)).toString()}
        rows={rows}
        showVehicleSource={isVehicleSource}
        vehicleSourceLabel={this.props.translate(
          'activity.vehiclesource-activity',
        )}
      />
    )
  }
}
